import { defineComponent } from 'vue'

export const Badge = defineComponent({
  props: {
    color: { type: String, default: '#235058' },
    backgroundColor: { type: String, default: '#EAF0F2' },
  },
  setup (props, { slots }) {
    return () => {
      const { backgroundColor, color } = props
      return (
        <div
          class="inline-block text-xs font-bold p-2 rounded-xl text-center"
          style={{
            backgroundColor,
            color,
          }}
        >
          {slots.default?.()}
        </div>
      )
    }
  },
})
